/*
 * Copyright (c) 2024. Tooling Team
 */
// Local development settings
// export const BASE_URL = "http://localhost:15993/cmt/";
// export const MEDMAPPER_BASE_URL = "http://localhost:15993/cmt-medmapper/";
// export const MEDMAPPER_EIS_BASE_URL = MEDMAPPER_BASE_URL + "medmapper";
// export const BASE_URL = "http://localhost:3000/";

export const BASE_URL = process.env.REACT_APP_API_HOST;
export const MEDDOMAIN_BASE_URL = process.env.REACT_APP_MEDMAPPER_API_HOST;
export const MEDDOMAIN_EIS_BASE_URL =
  process.env.REACT_APP_API_HOST + "medmapper";
// Local development settings
//export const BASE_URL = "https://dev-phi.cmt.data-enablement.optum.com/cmt/";
//export const MEDDOMAIN_BASE_URL =
//  "https://api-stg.uhg.com/api/cloud/api-management/cmt-api-dev-phi/1.0.0/cmt-medmapper";
//export const MEDDOMAIN_EIS_BASE_URL =
//  "https://api-stg.uhg.com/api/cloud/api-management/cmt-api-dev-phi/1.0.0/cmt/medmapper";

export const MAP_ID = "0693f47f-5510-4cee-953a-54ddf448da19";

export const PATHS = {
  home: {
    displayName: "Home",
    url: "/",
  },
  forbidden: {
    url: "/forbidden",
  },
  mapManagement: {
    displayName: "Map Management",
    url: "/map-management",
  },
  createMap: {
    displayName: "Create Map",
    url: "/map-management/create-map",
  },
  editMap: {
    displayName: "Edit Map",
    url: "/map-management/edit-map",
  },
  editMapMapValueDefinition: {
    displayName: "Map Value Definition",
    url: "/map-management/edit-map/map-value-definition",
  },
  medDomain: {
    displayName: "Legacy Builds",
    url: "/legacyBuilds",
  },
  medDomainDetails: {
    displayName: "MedDomain Details",
    url: "/legacyBuilds/details/:build_id",
  },
  medDomainDiff: {
    displayName: "MedDomain Diff",
    url: "/legacyBuilds/v1/builds/diff",
  },
  medDomainEIS: {
    displayName: "Modern Builds",
    url: "/modernBuilds",
  },
  medDomainEISDetails: {
    displayName: "MedDomain Modern Details",
    url: "/modernBuilds/details/:correlation_id",
  },
  medDomainEISDiff: {
    displayName: "MedDomain Modern Diff",
    url: "/modernBuilds/v1/builds/diff",
  },
  labDomain: {
    displayName: "Lab Domain",
    url: "/labDomain/",
  },
  labDomainCodeEvidence: {
    displayName: "Lab Domain Code Evidence",
    url: "/labDomain/code-evidence",
  },
  conceptManagement: {
    displayName: "Concept Management",
    url: "/concept-management",
  },
  admin: {
    displayName: "Administration",
    url: "/admin",
  },
};

export const ROLES = {
  ROLE_ADMIN: "ADMIN",
  ROLE_DATA_ANALYST: "DATA_ANALYST",
};

export const ROW_TAGS = {
  DATA_SOURCE: "Data Source",
  SYNONYM_SOURCE: "Synonym Source",
};

export const SYSTEM_SUFFIX = "_codesystem";
export const CONCEPTS_SUFFIX = "_conceptset";

// Domain routed to the Lab module on map creation
export const LAB_DOMAIN_VALUE = "observation_code";
export const SELECT_SEARCH_CONCEPT_SETS_BY_CONDITION_LAB_DOMAIN_CONDITION = {
  criteria: {
    searchExpression: [
      {
        and: [
          { eq: { name: "observation_code_conceptset" } },
          { eq: { system: "LOINC" } },
        ],
      },
    ],
  },
};
